// Copyright (c) 2025 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export const AMP_COOKIES_KEY = 'AMP_COOKIES_ACCEPTED';
